export class Notifications {
    notificationId: string;
    notificationType: number;
    notifiers: Notifiers[];
    message: string;
    title: string;
    notificationCheckType: number;
}

export class Notifiers {
    userNotificationId: string;
    userId: string;
    actioned: boolean;
}

export class NotificationAck {
    userNotificationId: string;
    actioned: boolean;
}
